/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import LabelledField from "components/labelled-field";
import { ComponentCardsEditWrapper } from "./component-cards-wrapper";
import { CardsItemEditor } from "./cards-item";

const CardsComponentEditor = () => {
    const { component, update, updateFactory } = useUpdateComponent();
    
    const sectionName = component?.sectionName;
    const title = component?.title;
    const subtitle = component?.subtitle;
    const cardList = component?.card_list;

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };

    const onChangeSectionName = (event) => {
        const sectionName = event.target.value;
        update("sectionName", sectionName);
    };

    const onChangeSubtitle = (event) => {
        const subtitle = event.target.value;
        update("subtitle", subtitle);
    };

    const onChangeCardList = updateFactory("card_list");

    return (
        <div className="simplicity-editor-frame simplicity-cards-component-editor">
            <div className="simplicity-cards-component-editor-general">
                <LabelledField label="Section Name">
                    <TextField
                        id="cards_section_name"
                        fullWidth={true}
                        value={sectionName}
                        onChange={onChangeSectionName}
                        placeholder="Add a section name"
                    />
                </LabelledField>
                <LabelledField label="Title">
                    <TextField
                        id="cards_title"
                        fullWidth={true}
                        value={title}
                        onChange={onChangeTitle}
                        placeholder="Add a title"
                    />
                </LabelledField>
                <LabelledField label="Subtitle">
                    <TextField
                        id="cards_subtitle"
                        fullWidth={true}
                        value={subtitle}
                        onChange={onChangeSubtitle}
                        placeholder="Add a subtitle"
                    />
                </LabelledField>
            </div>
            <div className="simplicity-cards-component-editor-list-wrapper">
                <ComponentCardsEditWrapper 
                    list={cardList}
                    onChange={onChangeCardList}
                >
                    <CardsItemEditor />
                </ComponentCardsEditWrapper>
            </div>
        </div>
    );
};
CardsComponentEditor.displayName = "CardsComponentEditor";
export { CardsComponentEditor };
